module.exports = "img/search.0323348.png";